export const FONTS = {
  PRIMARY: "Poppins",
  SECONDARY: "Source Sans Pro",
  DEFAULT: "sans-serif",
};
